import React, { useEffect, useContext, useRef } from 'react'
import { NextpageContext } from '../context/nextpage.context'

export type IDrawerProps = {
  headingList: any[],
  contentList: any[],
  noBackground?: boolean
}

function Drawer({ headingList, contentList, noBackground }: IDrawerProps) {
  const nextpage = useContext(NextpageContext)
  const drawerRef = useRef(null)
  const noBkgColor = 'no-bkg-color'



  useEffect(() => {
    nextpage.UI.components.drawers(drawerRef.current)
  })

  let drawerClass = `drawers ${noBackground ? noBkgColor : ''}`

  const drawers = headingList.map((hl, i) => (
    <React.Fragment key={i}>
      <div key={`tab-` + i} role='tab' className={`panel-heading`} aria-selected='false'>
        {<h4>{hl}</h4>}
      </div>
      <div key={`panel-` + i} className={`panel-content`} aria-expanded='false' role='tabpanel'>
        {contentList[i]}
      </div>
    </React.Fragment>
  ))
  return (
    <React.Fragment>
      <div ref={drawerRef} className={drawerClass} role='tablist'>
        {drawers}
      </div>
    </React.Fragment>
  )
}

export default Drawer